import React from 'react';
import { brands } from '../mock';

const BrandsSection = () => {
  return (
    <section id="brands" className="bg-gradient-to-b from-[#0a0a0a] to-[#1a1a1a] py-24">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-4xl sm:text-5xl font-black text-white mb-4">
            Trusted by Leading Fitness Brands
          </h2>
          <p className="text-xl text-gray-400">
            Partnered with 100+ brands to create content that converts
          </p>
        </div>

        <div className="grid grid-cols-2 md:grid-cols-4 gap-6">
          {brands.map((brand) => (
            <div
              key={brand.id}
              className="group relative bg-gradient-to-br from-gray-900 to-black border border-gray-800 rounded-lg p-8 hover:border-[#00ff41] transition-all duration-300 hover:scale-105"
            >
              <div className="text-center">
                <div className="text-2xl font-black text-white mb-2 group-hover:text-[#00ff41] transition-colors">
                  {brand.name}
                </div>
                <div className="text-sm text-gray-500 font-medium">{brand.category}</div>
              </div>
            </div>
          ))}
        </div>

        <div className="mt-16 text-center">
          <div className="inline-block bg-gradient-to-r from-[#00ff41]/10 to-[#ff6b35]/10 border border-[#00ff41]/30 rounded-lg p-8">
            <p className="text-lg text-gray-300 mb-4">
              <span className="text-[#00ff41] font-bold text-2xl">Average Campaign Results:</span>
            </p>
            <div className="grid grid-cols-1 sm:grid-cols-3 gap-6 mt-4">
              <div>
                <div className="text-3xl font-black text-white">340%</div>
                <div className="text-sm text-gray-400">Average ROI</div>
              </div>
              <div>
                <div className="text-3xl font-black text-white">2.5M+</div>
                <div className="text-sm text-gray-400">Avg. Impressions</div>
              </div>
              <div>
                <div className="text-3xl font-black text-white">9.2%</div>
                <div className="text-sm text-gray-400">Avg. Engagement</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default BrandsSection;
